/** Optional social handles. Stored without leading @, displayed with one. */
export interface UserSocials {
  instagram: string | null
  tiktok: string | null
  snapchat: string | null
}

/** Max length of a user's profile bio. */
export const MAX_BIO_LENGTH = 160

/**
 * A KandiTag account. Created when an anonymous session upgrades (email/Google).
 * `handle` is globally unique — enforced via a Firestore transaction in
 * userService.claimHandle. Always stored without `@`, always displayed with it.
 */
export interface User {
  userId: string
  /** Stored without `@`. Always rendered with an `@` prefix in the UI. */
  handle: string
  /** Free-text bio shown on the public profile. Empty string when unset. */
  bio: string
  /** Home city (e.g. "Seattle, WA"), shown on the public profile. Null when unset. */
  homeCity: string | null
  photoUrl: string | null
  socials: UserSocials
  /** User ids this person has blocked; their posts are filtered from view. */
  blockedUserIds: string[]
  createdAt: Date
}
